import mediator from "@tvg/mediator";
import { get } from "lodash";
import { EventData, EventProps, MediatorEventType } from "./types";
import { track } from "../../amplitude";
import { BaseEventProps } from "../../types";
import { EVENT_NAME } from "./constants";

export default () => {
  mediator.base.subscribe(MediatorEventType.START, () =>
    track<EventProps>(EVENT_NAME.START, {
      [BaseEventProps.EVENT_CATEGORY]: "Login",
      [BaseEventProps.MODULE]: "Modal"
    })
  );

  mediator.base.subscribe(MediatorEventType.ATTEMPT, () =>
    track<EventProps>(EVENT_NAME.ATTEMPT, {
      [BaseEventProps.EVENT_CATEGORY]: "Login",
      [BaseEventProps.MODULE]: "Modal"
    })
  );

  mediator.base.subscribe(MediatorEventType.SUCCESS, (data: EventData) =>
    track<EventProps>(EVENT_NAME.SUCCESS, {
      [BaseEventProps.EVENT_CATEGORY]: "Login",
      [BaseEventProps.MODULE]: "Modal",
      [BaseEventProps.ACCOUNT_ID]: get(data, "payload.accountId"),
      [BaseEventProps.REGISTRATION_STATUS]: "Registered"
    })
  );

  mediator.base.subscribe(MediatorEventType.ERROR, (data: EventData) =>
    track<EventProps>(EVENT_NAME.ERROR, {
      [BaseEventProps.EVENT_CATEGORY]: "Login",
      [BaseEventProps.EVENT_LABEL]: get(data, "payload.error"),
      [BaseEventProps.MODULE]: "Modal"
    })
  );

  mediator.base.subscribe(MediatorEventType.FIELD_COMPLETE, (data: EventData) =>
    track<EventProps>(EVENT_NAME.FIELD_COMPLETE, {
      [BaseEventProps.EVENT_CATEGORY]: "Login",
      [BaseEventProps.EVENT_LABEL]: get(data, "payload.field"),
      [BaseEventProps.MODULE]: "Modal"
    })
  );

  mediator.base.subscribe(MediatorEventType.SELECT_STATE, (data: EventData) =>
    track<EventProps>(EVENT_NAME.SELECT_STATE, {
      [BaseEventProps.EVENT_CATEGORY]: "Login",
      [BaseEventProps.EVENT_LABEL]: get(data, "payload.state"),
      [BaseEventProps.MODULE]: "Modal"
    })
  );

  mediator.base.subscribe(MediatorEventType.FORGOT_CREDENTIALS, () =>
    track<EventProps>(EVENT_NAME.FORGOT_CREDENTIALS, {
      [BaseEventProps.EVENT_CATEGORY]: "Login",
      [BaseEventProps.MODULE]: "Header"
    })
  );
};
